import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./BlogDetails.css";
import "./Blogs.css";
import RelatedArticles from "./RelatedArticles";
import PreLoader from "./PreLoader";
import { Helmet } from "react-helmet-async";

function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getUTCDate();

    const suffix =
        day % 10 === 1 && day !== 11 ? "st" :
            day % 10 === 2 && day !== 12 ? "nd" :
                day % 10 === 3 && day !== 13 ? "rd" : "th";

    const month = date.toLocaleDateString("en-GB", {
        month: "short",
        timeZone: "UTC"
    });

    const year = date.getUTCFullYear();

    return `${day}${suffix} ${month}, ${year}`;
}

function BlogDetails() {
    const { slug } = useParams();

    const [blog, setBlog] = useState(null);
    const [recentBlogs, setRecentBlogs] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogDetails = async () => {
            try {
                setLoading(true);
                setError(null);
                setBlog(null);

                const response = await fetch(
                    `https://admin.360-bytes.com/api/getBlog/${slug}`
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch blog details.");
                }

                const result = await response.json();

                // API response contains the blog inside "data"
                setBlog(result.data);
                setRecentBlogs(result.recent_blogs);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogDetails();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [slug]);

    if (loading) {
        return <PreLoader content="Loading blog details..." />;
    }

    if (error) {
        return (
            <div className="blog-state-wrapper">
                <div className="container">
                    <div className="blog-state-card">
                        <p>Error: {error}</p>
                        <Link to="/blogs" className="btn-back">
                            Back to Blogs
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    if (!blog) {
        return (
            <div className="blog-state-wrapper">
                <div className="container">
                    <div className="blog-state-card">
                        <p>Blog not found.</p>
                        <Link to="/blogs" className="btn-back">
                            Back to Blogs
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>

            <Helmet>
                <title>{blog.meta_title || blog.title}</title>
                <meta name="title" content={blog.meta_title || blog.title} />
                <meta name="description" content={blog.meta_description || ""} />
                <meta name="keywords" content={blog.meta_keywords || ""} />
            </Helmet>

            <article className="hmslder-sec abt-sec">

                <div className="breadcrumbs">
                    <div className="container">
                        <ul>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/blogs">Blogs</Link>
                            </li>
                            <li>{blog.title}</li>
                        </ul>
                    </div>
                </div>
            </article>

            <div className="blog-details-sec">
                <div className="container">
                    <div className="blog-details-inner">
                        {/* Title */}
                        <h1 className="blog-title">{blog.title}</h1>

                        {/* Metadata Bar */}
                        {/* <div className="blog-meta-info">
                            <div className="blog-meta-item">
                                <span className="blog-meta-label">Author:</span>
                                <span className="blog-meta-value">
                                    {blog.author?.name || "N/A"}
                                </span>
                            </div>

                            <div className="blog-meta-item">
                                <span className="blog-meta-label">Status:</span>
                                <span className="blog-status-badge">
                                    {blog.status}
                                </span>
                            </div>

                            <div className="blog-meta-item">
                                <span className="blog-meta-label">Published:</span>
                                <span className="blog-meta-value">
                                    {blog.published_at ? formatDate(blog.published_at) : "N/A"}
                                </span>
                            </div>

                            <div className="blog-meta-item">
                                <span className="blog-meta-label">
                                    Estimated reading time:
                                </span>
                                <span className="blog-meta-value">
                                    {blog.estimated_reading_time} minute(s)
                                </span>
                            </div>
                        </div> */}

                        {/* Featured Image */}
                        {blog.featured_image_url && (
                            <div className="blog-featured-image-wrapper">
                                <img
                                    src={blog.featured_image_url}
                                    alt={blog.featured_image_alt || blog.title}
                                    className="blog-featured-image"
                                />
                            </div>
                        )}

                        {/* Description */}
                        <div className="blog-description-section">
                            {/* <h3 className="blog-section-title">Description</h3> */}
                            <div
                                className="blog-rich-content"
                                dangerouslySetInnerHTML={{
                                    __html: blog.description || "",
                                }}
                            />
                        </div>

                        {/* SEO Details */}
                        {/* <div className="blog-seo-section">
                            <h3 className="blog-section-title">SEO Details</h3>
                            <div className="blog-seo-card">
                                <div className="blog-seo-row">
                                    <span className="blog-seo-label">
                                        Meta Title:
                                    </span>
                                    <span className="blog-seo-value">
                                        {blog.meta_title || "N/A"}
                                    </span>
                                </div>

                                <div className="blog-seo-row">
                                    <span className="blog-seo-label">
                                        Meta Description:
                                    </span>
                                    <span className="blog-seo-value">
                                        {blog.meta_description || "N/A"}
                                    </span>
                                </div>

                                <div className="blog-seo-row">
                                    <span className="blog-seo-label">
                                        Meta Keywords:
                                    </span>
                                    <span className="blog-seo-value">
                                        {blog.meta_keywords || "N/A"}
                                    </span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {recentBlogs && recentBlogs.length > 0 && (
                <RelatedArticles recentBlogs={recentBlogs} />
            )}

            {/* <section className='cont-sec'>
                <div className='container'>
                    <div className='mn-head'>
                        <h5>Recent articles</h5>
                    </div>
                    <ul>
                        {
                            recentBlogs?.map((blog, index) => (
                                <BlogCard key={index} blog={blog} />
                            ))
                        }
                    </ul>
                </div>
            </section> */}
        </>
    );
}

export default BlogDetails;
